import { JobData } from '../job-data';

export class JobDataSerializer {
    fromJson(json: any): JobData {
        const data = new JobData();
        data.jobId=json.jobId;
        data.technologyName=json.technologyName;
        data.technologyId=json.technologyId;
        data.jobDescriptionId=json.jobDescriptionId;
        data.jobDescriptionName=json.jobDescriptionName;
        data.roleName=json.roleName;
        data.roleId=json.roleId;
        data.jobStatusName=json.jobStatusName ? json.jobStatusName : 'N/A';
        data.jobStatusId = json.jobStatusId ? json.jobStatusId : 'N/A';
        data.jobPriortyName=json.jobPriortyName ? json.jobPriortyName : 'N/A';
        data.jobPriortyId = json.jobPriortyId ? json.jobPriortyId : 'N/A';
        data.noOfVacancies = json.noOfVacancies;
        data.createdOn = json.createdOn;
        data.openJobCount=json.openJobCount;
        data.pendingJobCount =json.pendingJobCount;
        data.closedJobCount=json.closedJobCount;
        return data;
    }

    toJson(data: JobData): any {
        return {
        jobId: data.jobId,
        technologyName: data.technologyName,
        technologyId: data.technologyId,
        jobDescriptionId: data.jobDescriptionId,
        jobDescriptionName: data.jobDescriptionName,
        roleName: data.roleName,
        roleId: data.roleId,
        jobStatusName: data.jobStatusName,
        jobStatusId: data.jobStatusId,
        jobPriortyName: data.jobPriortyName,
        jobPriortyId: data.jobPriortyId,
        noOfVacancies: data.noOfVacancies,
        createdOn: data.createdOn,
        openJobCount: data.openJobCount,
        pendingJobCount: data.pendingJobCount,
        closedJobCount: data.closedJobCount,
        };
    }
}
